import { useSuspenseQuery } from "@apollo/client/react";
import { useMemo } from "react";
import {
  GetEvidenceSetDetailDocument,
  type GetEvidenceSetDetailQuery,
  type GetEvidenceSetDetailQueryVariables,
} from "~/features/dataImportProjects/gqls";
import type { PropertySchemaSetFormData } from "~/features/dataImportProjects/types";
import { PropertySchemasMapper } from "~/features/dataImportProjects/utils/propertySchemasMapper";
import { useTenant } from "~/features/tenant/context";

type Props = {
  evidenceSetId: string;
};

export const useEvidenceSetPropertySchemaSet = ({
  evidenceSetId,
}: Props): { propertySchemaSet?: PropertySchemaSetFormData } => {
  const { tenantId } = useTenant();
  if (!tenantId) {
    throw new Error("Tenant ID is required");
  }
  const { data } = useSuspenseQuery<GetEvidenceSetDetailQuery, GetEvidenceSetDetailQueryVariables>(
    GetEvidenceSetDetailDocument,
    {
      variables: { tenantId, id: evidenceSetId },
    },
  );

  const evSet = data?.evidenceSets?.[0];

  const schemaSet = evSet?.evidenceSetPropertySchemaSet?.propertySchemaSet;
  const propertySchemaSet = useMemo(
    () =>
      schemaSet
        ? {
            id: schemaSet.id,
            name: evSet.name,
            propertySchemaAssociations:
              schemaSet?.propertySchemaAssociations.map(PropertySchemasMapper.propertySchemaAssociation.toFormData) ??
              [],
          }
        : undefined,
    [evSet, schemaSet],
  );

  return { propertySchemaSet };
};
